import { ReactNode } from 'react';
import { FieldWrapper, InputWrapper, Label } from './Input.styled';
type Props = {
  label?: string;
  direction?: boolean;
  smallLabel?: boolean;
  children: ReactNode;
};

export default function InputField({ label, direction, children, smallLabel }: Props) {
  return (
    <FieldWrapper vertical={direction} small={smallLabel}>
      {label && <Label>{label}</Label>}
      <InputWrapper>{children}</InputWrapper>
    </FieldWrapper>
  );
}
